import * as types from '../constants';

const initialState = {
   isLoading: false,
};

export default function reducer(state = initialState, actions) {
   switch (actions.type) {
      case types.HTTP_REQUEST_START:
         return {
            ...state,
            isLoading: true,
         };
      case types.HTTP_REQUEST_END:
         return {
            ...state,
            isLoading: false,
         };

      default:
         return state;
   }
}
